import { render, staticRenderFns } from "./TitleWidget.vue?vue&type=template&id=27a527ef&functional=true&"
import script from "./TitleWidget.vue?vue&type=script&lang=js&"
export * from "./TitleWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports